import { ErrorHandler, Injectable } from '@angular/core';

/**
 * Custom error handler to suppress NG0912 warnings from Angular Material/CDK components
 * and TanStack Table nested key warnings.
 * These warnings occur when Material components are imported across multiple standalone components
 * and when TanStack Table accesses undefined nested properties - both are benign and don't affect functionality.
 */
@Injectable()
export class NG0912SuppressorErrorHandler implements ErrorHandler {
	constructor() {
		// Suppress TanStack Table "returned undefined" warnings
		const originalWarn = console.warn;
		console.warn = (...args: unknown[]) => {
			const message = args[0];
			if (typeof message === 'string' && message.includes('deeply nested key') && message.includes('returned undefined')) {
				// Suppress these warnings completely - they happen when optional nested properties don't exist
				return;
			}
			originalWarn.apply(console, args);
		};
	}
	handleError(error: unknown): void {
		const errorMessage = (error as Error)?.message || String(error);

		// Check if it's an NG0912 error
		if (typeof errorMessage === 'string' && errorMessage.includes('NG0912')) {
			// Suppress every NG0912 coming from Material/CDK internals (__CdkOverlayStyleLoader,
			// _CdkDialogContainer, _MatOption, _MatFormField, ...) - they are all benign here.
			// Log to console in development only
			if (!window.location.host.includes('localhost')) {
				return; // Completely suppress in production
			}
			// In development, log a simplified message
			console.debug('NG0912 warning suppressed for Material/CDK component');
			return;
		}

		// For all other errors, use default behavior
		console.error(error);
	}
}
